<template>
  <div class="details-container">
    <div class="details-header">
      <h2 v-if="videoFile?.file_nickname" :title="videoFile?.file_name">{{ videoFile?.file_nickname }}</h2>
      <h2 v-else-if="videoFile?.file_name" :title="videoFile?.file_name">{{ videoFile?.file_name }}</h2>
      <h2 v-else>Video File Details</h2>
    </div>
    
    <div v-if="videoFile" class="details-content">
      <div class="details-section" v-if="videoFile.stream_url">
        <h3>Review</h3>
        <div class="details-group full-width">
          <!-- Video Player Section -->
          <VideoFilePlayer
            :streamUrl="videoFile.stream_url"
            ref="videoPlayer" 
          />
        </div>
        <div class="details-group full-width">
          <ReviewComments 
            :videoFile="videoFile" 
            :videoPlayer="videoPlayer"
          />
        </div>
      </div>
      <div class="details-section" v-else>
        <h3>Review</h3>
        <div class="details-group full-width">
          Video Player and Review Notes will be available once the video file is encoded.
        </div>
      </div>
      
      <!-- Video File Status Section -->
      <div class="details-section">
        <h3>Technical Details</h3>
        <div class="details-group full-width">
          <VideoFileStatus :video-file="videoFile" />
        </div>
      </div>

      <div class="details-actions">
        <router-link 
          :to="`/admin/videofiles/${videoFileId}/edit`"
          class="important-button big"
          v-if="isSuperuser()"
        >
          Edit Video File
        </router-link>
        <router-link 
          :to="`/videofiles/${videoFile.id}/encode`" 
          class="important-button big"
          title="Encode"
          v-if="videoFile.stream_status === 'NotStarted'"
        >
          Encode Video File
        </router-link>
        <button class="cancel-button medium" @click="goBack">Back</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { handleApiError } from '@/scripts/shared-utils';
import { isSuperuser } from '@/scripts/permissions';
import VideoFilePlayer from '@/components/VideoFilePlayer.vue';
import VideoFileStatus from '@/components/VideoFileStatus.vue';
import ReviewComments from '@/components/ReviewComments.vue';

const route = useRoute();
const router = useRouter();
const videoFileId = ref(route.params.video_file_id);
const videoFile = ref(null);
const videoPlayer = ref(null);

const fetchVideoFile = async () => {
  try {
    const response = await axios.get(`/api/video-files/${videoFileId.value}`);
    if (response.status === 200) {
      videoFile.value = response.data;
    }
  } catch (error) {
    handleApiError(error, 'fetching video file');
    videoFile.value = null;
  }
};

const goBack = () => {
  router.back();
};

onMounted(async () => {
  if (videoFileId.value) {
    await fetchVideoFile();
  }
});
</script>

<style scoped>
@import '@/styles/shared-details.css';
</style>
